<template>
    <td>
        <span v-if="isCurrency">{{ budget | toCurrency }}</span>
        <span v-else>{{ budget }}</span>
    </td>
</template>

<script>
    export default {
        props: {
            'budget': Number
        },
        computed: {
            isCurrency() {
                if (this.$vnode.key.includes('fte')) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
</script>
